import { render, staticRenderFns } from "./front-page.vue?vue&type=template&id=8de848f8&"
import script from "./front-page.vue?vue&type=script&lang=js&"
export * from "./front-page.vue?vue&type=script&lang=js&"
import style0 from "./front-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports